var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sms-input" },
    [
      _c(
        "div",
        { staticClass: "phone-input" },
        [
          _c("vue-country-code", {
            staticClass: "col-3 country-code",
            attrs: { enabledCountryCode: true, defaultCountry: "TR" },
            on: {
              onSelect: function ($event) {
                return _vm.onSelect($event)
              },
            },
          }),
          _vm._v(" "),
          _c("a-input", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: "############",
                expression: "'############'",
              },
            ],
            attrs: {
              placeholder: _vm.$t("message.phone"),
              autocomplete: "off",
              trim: "",
              type: "text",
            },
            model: {
              value: _vm.cloneValue.number,
              callback: function ($$v) {
                _vm.$set(_vm.cloneValue, "number", $$v)
              },
              expression: "cloneValue.number",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-select",
        {
          scopedSlots: _vm._u([
            {
              key: "suffixIcon",
              fn: function () {
                return [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("add_to_home_screen"),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.cloneValue.senderId,
            callback: function ($$v) {
              _vm.$set(_vm.cloneValue, "senderId", $$v)
            },
            expression: "cloneValue.senderId",
          },
        },
        [
          _vm._v(" "),
          _c(
            "a-select-option",
            { attrs: { selected: true, value: "PSTCELLTEST" } },
            [_vm._v("PSTCELLTEST")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-select",
        {
          scopedSlots: _vm._u([
            {
              key: "suffixIcon",
              fn: function () {
                return [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("settings_cell"),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.cloneValue.channelId,
            callback: function ($$v) {
              _vm.$set(_vm.cloneValue, "channelId", $$v)
            },
            expression: "cloneValue.channelId",
          },
        },
        [
          _vm._v(" "),
          _vm._l(_vm.smsChannels, function (channel) {
            return _c(
              "a-select-option",
              { key: channel._id, attrs: { value: channel._id } },
              [_vm._v("\n            " + _vm._s(channel.name) + "\n        ")]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }